import {Config} from '../../util';

const TIME_OUT = 1000 * 90; //0.3;

const timeOutFetch = () =>{
    return new Promise(resolve => {
      setTimeout(resolve, TIME_OUT, {
        code: '408',
        content: '시간초과 에러',
        detail: 'HTTP 통신 시간지연 오류'
      });
  });
};





const once = (fn, context) => {
    let result;
    return () => {
      if (fn) {
            result = fn.apply(context || this, arguments);
            fn = null;
        }
        return result;
    }
}

const sessionTimeOutFn = once(() => {
    alert("장시간 미사용으로 로그아웃 되었습니다.");
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = "/";
});

const timeFetch = (url, data ,method) => {

    const httpHeader = {};
    httpHeader.method = method;
    httpHeader.headers = {
        "Content-Type": "application/json",
    };
    if (method === 'POST') httpHeader.body = data;

    return fetch(url, httpHeader)
    .then(data => {
        if(data.ok){
            return data.json();
        }else{
            return {
                code: '404',
                content: "통신 문제",
                detail: "네트워크 문제"
            };
        }
    })
    .then(response => {
        const {head} = response.queryResult || response.root;
        if(head.errorCode === '0'){
            return {
                files: response.queryResult.data,
                key: head
            };
        }else if(head.errorCode === '10000'){
            sessionTimeOutFn();
        }else{
            return {
                code: head.errorCode,
                content: "서비스 오류",
                detail: head.message
            };
        }
    })
    .catch(error => {
        return {
            code: '415',
            content: "HTTP 통신문제 발생",
            detail: error.message
        };
    });
}

const Ajax = (data, method='POST', url=Config.wsurl) => {
    if(!data) throw TypeError('Invalid Arguments: data가 없습니다.');
    if(method === 'GET') url += '?'+ data;
    return new Promise((resolve, reject) => {
        Promise.race([timeOutFetch(),timeFetch(url, data, method.toUpperCase())])
        .then(response => {
            if(response.code){
                reject(response);                
            }else{
                resolve(response);
            }
        });
    })

};

export default Ajax;


// WEBPACK FOOTER //
// ./src/util/api/Ajax.js